import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { type SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import TextInput from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { StepEvent, StepParams } from './StepParams'
import {
  EducationLevelOptions,
  IndustryOptions,
  JobFunctionOptions,
  SeniorityOptions,
} from './VonqData'

const sorted = (options: SelectOption[]) => options.sort((a, b) => a.label.localeCompare(b.label))

export const VonqCampaign = observer(
  ({ onStepEvent, onClose, progress, vonqCampaignForm }: StepParams) => {
    const educationLevelOptions: SelectOption[] = EducationLevelOptions.map((option) => ({
      label: option.name,
      value: option.id,
    }))
    const seniorityOptions: SelectOption[] = SeniorityOptions.map((option) => ({
      label: option.name,
      value: option.id,
    }))
    const industryOptions: SelectOption[] = sorted(
      IndustryOptions.map((option) => ({ label: option.name, value: option.id }))
    )
    const jobCategoryOptions: SelectOption[] = sorted(
      JobFunctionOptions.map((option) => ({ label: option.name, value: option.id }))
    )

    return (
      <Modal
        title={i18n.t('ats.job_details.promotion.vonq.linkedin.campaign_step.title')}
        description={i18n.t('ats.job_details.promotion.vonq.campaign_step.description', {
          step: progress.amount,
        })}
        illustration="document-edit"
        onClose={onClose}
        footer={
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Button disabled={false} onClick={() => onStepEvent(StepEvent.Back)}>
              {i18n.t('ats.job_details.promotion.vonq.campaign_step.back')}
            </Button>
            <Button
              disabled={!vonqCampaignForm.isComplete}
              onClick={() => onStepEvent(StepEvent.Next)}
            >
              {i18n.t('ats.job_details.promotion.vonq.campaign_step.next')}
            </Button>
          </Box>
        }
        progress={progress}
      >
        <Box gap="s16" flexDirection="column">
          <TextInput
            type="number"
            label={i18n.t(
              'ats.job_details.promotion.vonq.campaign_step.fields.years_of_experience'
            )}
            field={vonqCampaignForm.get('yearsOfExperience')}
            mandatory
          />
          <Select
            label={i18n.t('ats.job_details.promotion.vonq.campaign_step.fields.education_level')}
            options={educationLevelOptions}
            field={vonqCampaignForm.get('educationLevel')}
            mandatory
            none={i18n.t('common.choose')}
          />
          <Select
            label={i18n.t('ats.job_details.promotion.vonq.campaign_step.fields.seniority')}
            options={seniorityOptions}
            field={vonqCampaignForm.get('seniority')}
            mandatory
            none={i18n.t('common.choose')}
          />
          <Select
            label={i18n.t('ats.job_details.promotion.vonq.campaign_step.fields.industry')}
            options={industryOptions}
            field={vonqCampaignForm.get('industry')}
            mandatory
            none={i18n.t('common.choose')}
          />
          <Select
            label={i18n.t('ats.job_details.promotion.vonq.campaign_step.fields.job_category')}
            options={jobCategoryOptions}
            field={vonqCampaignForm.get('jobCategory')}
            mandatory
            none={i18n.t('common.choose')}
          />
        </Box>
      </Modal>
    )
  }
)
